$(function () {
  window.VUtils = {}
  VUtils.reloadShopifySection = function (initFunction) {
    initFunction();
    if (Shopify.designMode) {
      $(document)
        .on('shopify:section:load', initFunction)
        .on('shopify:section:unload', initFunction)
        .on('shopify:section:reorder', initFunction);
    }
  };
  VUtils.loadTooltip = function () {
    $('[data-toggle="tooltip"]').tooltip();
  };
  VUtils.loadTooltip();
  /**
   * Get the width and height of an element or browser scrollbar
   * @param ele dom element
   * @returns {{horizontal: number, vertical: number}}
   */
  VUtils.scrollWidth = function (ele) {
    var tempDiv;
    var tempInnerDiv = document.createElement('div');
    var result = {
      vertical: 0,
      horizontal: 0
    };
    tempInnerDiv.style.cssText = 'width: 200px;height: 200px';
    if (!ele || ele.nodeType != 1) {
      // Get the browser's scrollbar if no dom element is passed
      result.vertical = window.innerWidth - document.documentElement.offsetWidth;
      result.horizontal = window.innerHeight - document.documentElement.clientHeight;
      return result;
    }
    tempDiv = ele.cloneNode(true);
    tempDiv.style.cssText = 'width: 100px;height: 100px;opacity: 0;position:absolute;left: -100px;overflow:auto;';
    tempDiv.appendChild(tempInnerDiv);
    document.body.appendChild(tempDiv);
    result.vertical = tempDiv.offsetWidth - tempDiv.clientWidth;
    result.horizontal = tempDiv.offsetHeight - tempDiv.clientHeight;
    document.body.removeChild(tempDiv);
    tempDiv = tempInnerDiv = null;
    return result;
  }
  /**
   * Determine if a browser or dom element has a scrollbar
   * @returns {{horizontal: boolean, vertical: boolean}}
   */
  VUtils.hasScroll = function () {
    return {
      vertical: document.body.scrollHeight > window.innerHeight,
      horizontal: document.body.scrollWidth > window.innerWidth
    };
  }
  // Lock scrollbar
  VUtils.lockScroll = function () {
    const lockClass = 'v-lock-scroll';
    let body = document.body;
    // Records the properties of the body before locking the scrollbar to restore the pre-lock style after unlocking
    let originBodyOverflow = body.style.overflow;
    let originBodyPaddingRight = body.style.paddingRight;
    let originBodyPaddingBottom = body.style.paddingBottom;
    let originBodyHasLockClass = body.classList.contains(lockClass);
    let hasScroll = VUtils.hasScroll();
    let scrollWidth = VUtils.scrollWidth();
    // Mark whether the page is locked this time
    let locked = false;
    if (!originBodyHasLockClass) {
      body.classList.add(lockClass);
    }
    if (originBodyOverflow != 'hidden') {
      body.style.overflow = 'hidden';
      locked = true;
      if (hasScroll.vertical) {
        body.style.paddingRight = scrollWidth.vertical + 'px';
      }
      if (hasScroll.horizontal) {
        body.style.paddingBottom = scrollWidth.horizontal + 'px';
      }
    }
    // Returns a function that unlocks the scrollbar
    return function () {
      let body = document.body;
      if (!originBodyHasLockClass) {
        body.classList.remove(lockClass);
      }
      if (!locked) {
        return;
      }
      if (originBodyOverflow) {
        body.style.overflow = originBodyOverflow;
      } else {
        // Remove the overflow attribute from the body
        body.style.overflow = '';
      }
      if (originBodyPaddingRight && parseFloat(originBodyPaddingRight) !== scrollWidth.vertical) {
        body.style.paddingRight = originBodyPaddingRight;
      } else {
        // Remove the paddingRight property from the body
        body.style.paddingRight = '';
      }
      if (originBodyPaddingBottom && parseFloat(originBodyPaddingBottom) !== scrollWidth.horizontal) {
        body.style.paddingBottom = originBodyPaddingBottom;
      } else {
        // Remove the paddingBottom property from the body
        body.style.paddingBottom = '';
      }
    };
  };
  VUtils.urlEncode = function (params) {
    let paramsArray = [];
    Object.keys(params).forEach(key => params[key] && paramsArray.push(`${key}=${params[key]}`));
    return paramsArray.join('&');
  }
  VUtils.queryURLParams = function (URL) {
    let url = URL.split("?")[1];
    const urlSearchParams = new URLSearchParams(url);
    const params = Object.fromEntries(urlSearchParams.entries());
    return params;
  }
  // 生成blog文章目录
  VUtils.createTableOfContents = function (current, target) {
    if(!(document.querySelector(current) && document.querySelector(target))) return;
    const titleTree = tree(document.querySelector(current));
    const box = document.querySelector(target);
    creatEle(titleTree, box);

    function tree(wrapNode) {
      const hTagsList = ['h1', 'h2', 'h3', 'h4', 'h5', 'h6']
      const root = { children: [] }
      let current = root
      Array.from(wrapNode.children)
        .filter(item => hTagsList.includes(item.localName))
        .forEach(item => {
          const tagId = textSpaceToUnderline(item.innerText);
          item.setAttribute('id', tagId.encodeText);
          const obj = { node: item, children: [], parent: undefined }
          while (current !== root && current.node.localName[1] - obj.node.localName[1] !== -1) {
            current = current.parent
          }
          obj.parent = current
          obj.parent.children.push(obj)
          current = obj
        })
      return root.children
    }

    function creatEle(arr, parent) {
      if (!arr.length) return
      const ol = document.createElement('ol');
      arr.forEach(item => {
        const li = document.createElement('li');
        const tagId = textSpaceToUnderline(item.node.innerText);
        li.innerHTML = `<a href="#${tagId.encodeText}">${item.node.innerText}</a>`;
        creatEle(item.children, li);
        ol.appendChild(li);
      })
      parent.appendChild(ol);
    }

    function textSpaceToUnderline(innerText) {
      const splitTextArr = innerText.split(' ');
      let text = '';
      for(let i = 0; i < splitTextArr.length; i++) {
        const lowercaseCharacters = (splitTextArr[i]).trim().toLowerCase();
        if(lowercaseCharacters) {
          text += lowercaseCharacters + '_';
        }
      }
      const returnText = text.length > 0 ? (text.replace(/_+$/,'')) : '';
      const encodeReturnText = encodeURIComponent(returnText);
      return {
        text: returnText,
        encodeText: encodeReturnText
      };
    }
  }
})